import { render } from "./ServicegroupsDetails.vue?vue&type=template&id=6c7836e1&scoped=true"
import script from "./ServicegroupsDetails.vue?vue&type=script&lang=js"
export * from "./ServicegroupsDetails.vue?vue&type=script&lang=js"

import "./ServicegroupsDetails.vue?vue&type=style&index=0&id=6c7836e1&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7836e1"]])

export default __exports__